<template>
  <div class="content">
    <!-- <h3 ref="pageHeader" class="pageHeader">安全承诺书签字</h3> -->
    <div class="pdf-preview" v-loading="loading">
      <div v-if="pdfPromise && numPages > 0" class="pdf-container">
        <!-- <div v-for="page in numPages" :key="page" class="pdf-page-wrapper">
          <pdf :src="pdfPromise" :page="page" class="pdf-page" @loaded="onPageLoaded" @error="onPageError"></pdf>
        </div> -->
        <el-image v-for="(img, index) in previewImages" class="pdf-page" :key="index" :src="img"
          :preview-src-list="previewImages">
        </el-image>
      </div>
      <el-empty v-else description="暂无承诺书"></el-empty>
    </div>
    <div class="sign-box" v-if="signType == 'sign'">
      <el-button type="primary" @click="openDialog">点击签字</el-button>
    </div>
    <el-dialog :visible.sync="dialogVisible" title="请在此处签字" width="580px" class="signature-dialog" append-to-body
      :close-on-click-modal="false" @closed="resetSignature" @opened="initCanvas" >
      <div class="signature-wrapper">
        <canvas ref="canvas" class="signature-canvas" :width="canvasWidth" :height="canvasHeight"></canvas>
        <div v-if="isEmpty" class="placeholder-text">
          请在此处签字
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clearCanvas" :disabled="isEmpty" style="margin-right: 8px;">
          <i class="el-icon-refresh-right"></i> 重签
        </el-button>
        <el-popconfirm title="确认要保存签字吗？" @confirm="saveSignature">
          <el-button type="primary" slot="reference" :loading="submitting" :disabled="isEmpty">
            <i class="el-icon-check"></i> 保存签字
          </el-button>
        </el-popconfirm>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pdf from 'vue-pdf'

export default {
  // components: {
  //   pdf
  // },
  props: {
    signType: {
      type: String,
      default: 'view'
    },
    studentId: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      pdfPromise: null,
      numPages: 0,
      loading: true,
      previewImages: [], // 预览图片数组
      showImageViewer: false, // 控制图片预览器显示
      currentPreviewIndex: 0, // 当前预览的图片索引
      canvasCache: {},// 缓存 canvas 转换的图片
      dialogVisible: false,
      canvasWidth: 540,
      canvasHeight: 239,
      ctx: null,
      isDrawing: false,
      lastPoint: { x: 0, y: 0 },
      isEmpty: true,
      submitting: false
    }
  },
  mounted() {
    // this.getPdfFile()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
      this.isEmpty = true
    },

    async saveSignature() {
      if (this.isEmpty) return

      this.submitting = true
      try {
        const file = await this.canvasToFile()
        this.uploadSignature(file)

      } catch (error) {
        console.error('保存签字失败:', error)
        this.$message.error(`保存失败: ${error.message || '未知错误'}`)
      } finally {
        this.submitting = false
      }
    },

    canvasToFile() {
      return new Promise((resolve, reject) => {
        this.$refs.canvas.toBlob(
          blob => {
            if (!blob) return reject(new Error('生成图片失败'))
            const file = new File([blob], `signature_${Date.now()}.png`, {
              type: 'image/png',
              lastModified: Date.now()
            })
            resolve(file)
          },
          'image/png',
          0.92
        )
      })
    },

    async uploadSignature(file) {
      // 替换为你的实际API调用
      const formData = new FormData()
      formData.append('signature_file', file)
      let res = await this.$api.instance.interfaceServer(`api/safety_commitment/sign`, 'post', formData, { isQs: false, headersConfig: { 'Content-Type': 'multipart/form-data' } });
      if (res.code == 0) {
        this.$message.success('签字保存成功！')
        this.dialogVisible = false
        // 通知父级:签字已完成(父级据此关闭弹窗并继续后续流程,如进入考试)
        this.$emit('signed')
        this.getPdfFile()
      }
    },
    async getPdfFile() {

      try {
        const response = await this.$api.instance.interfaceServer(`api/safety_commitment/file`, 'get', { student_id: this.studentId }, { isLoadd: false, options: { responseType: 'blob' } });
        const blob = new Blob([response], { type: 'application/pdf' })
        // 创建对象 URL
        const objectUrl = URL.createObjectURL(blob)

        // 创建 PDF 加载任务
        this.pdfPromise = pdf.createLoadingTask(objectUrl)

        // 创建 Blob（直接使用二进制数据）


        // 获取页数
        const pdfDoc = await this.pdfPromise.promise
        this.numPages = pdfDoc.numPages
        await this.generateAllPageImages()
      } catch (error) {
        console.error('PDF 加载失败:', error)
        this.loading = false
      }
    }, // 预览指定页面

    // 生成所有页面的图片
    async generateAllPageImages() {
      if (this.previewImages.length > 0) return // 如果已生成，直接返回

      const images = []

      // 为每一页生成图片
      for (let i = 1; i <= this.numPages; i++) {
        const imageData = await this.renderPageToImage(i)
        images.push(imageData)
      }

      this.previewImages = images
    },

    // 将指定页面渲染为图片
    async renderPageToImage(pageNumber) {
      // 检查是否已缓存
      if (this.canvasCache[pageNumber]) {
        return this.canvasCache[pageNumber]
      }

      try {
        const pdfDoc = await this.pdfPromise.promise
        const page = await pdfDoc.getPage(pageNumber)
        this.loading = false

        // 设置渲染缩放（高清晰度）
        const scale = 2.0 // 2倍缩放，提高清晰度
        const viewport = page.getViewport({ scale })

        // 创建 canvas
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')

        canvas.height = viewport.height
        canvas.width = viewport.width

        // 渲染页面
        const renderContext = {
          canvasContext: context,
          viewport: viewport
        }

        await page.render(renderContext).promise

        // 转换为图片数据
        const imageData = canvas.toDataURL('image/png')

        // 缓存结果
        this.canvasCache[pageNumber] = imageData

        return imageData
      } catch (error) {
        console.error(`渲染页面 ${pageNumber} 失败:`, error)
        return ''
      }
    },

    closeImageViewer() {
      this.showImageViewer = false
    },
    onPageLoaded() {
      console.log('页面加载完成')
    },

    onPageError(error) {
      console.error('页面加载错误:', error)
    },

    initCanvas() {
      const canvas = this.$refs.canvas
      if (!canvas) return

      //  确保每次打开对话框都重新初始化上下文
      this.ctx = canvas.getContext('2d')
      this.setupCanvasStyle()

      // 清除可能存在的旧事件监听器，避免重复绑定
      this.removeEventListeners()
      this.addEventListeners()

      // 调整画布大小以适应容器
      this.adjustCanvasSize()

      // 初始清空画布
      this.clearCanvas()
    },

    setupCanvasStyle() {
      if (!this.ctx) return
      this.ctx.lineCap = 'round'
      this.ctx.lineJoin = 'round'
      this.ctx.lineWidth = 2.5
      this.ctx.strokeStyle = '#1a365d'
    },
    handleTouchStart(e) {
      e.preventDefault()
      if (e.touches.length === 1) {
        const touch = e.touches[0]
        this.startDrawing({
          clientX: touch.clientX,
          clientY: touch.clientY
        })
      }
    },

    handleTouchMove(e) {
      e.preventDefault()
      if (e.touches.length === 1) {
        const touch = e.touches[0]
        this.draw({
          clientX: touch.clientX,
          clientY: touch.clientY
        })
      }
    },

    addEventListeners() {
      const canvas = this.$refs.canvas
      if (!canvas) return

      // 鼠标事件
      canvas.addEventListener('mousedown', this.startDrawing)
      canvas.addEventListener('mousemove', this.draw)
      canvas.addEventListener('mouseup', this.stopDrawing)
      canvas.addEventListener('mouseout', this.stopDrawing)

      // 触摸事件
      canvas.addEventListener('touchstart', this.handleTouchStart, { passive: false })
      canvas.addEventListener('touchmove', this.handleTouchMove, { passive: false })
      canvas.addEventListener('touchend', this.stopDrawing)
    },
    removeEventListeners() {
      const canvas = this.$refs.canvas
      if (!canvas) return

      // 移除所有事件监听器
      canvas.removeEventListener('mousedown', this.startDrawing)
      canvas.removeEventListener('mousemove', this.draw)
      canvas.removeEventListener('mouseup', this.stopDrawing)
      canvas.removeEventListener('mouseout', this.stopDrawing)

      canvas.removeEventListener('touchstart', this.handleTouchStart)
      canvas.removeEventListener('touchmove', this.handleTouchMove)
      canvas.removeEventListener('touchend', this.stopDrawing)
    },
    startDrawing(e) {
      if (!this.ctx) return

      this.isDrawing = true
      const rect = this.$refs.canvas.getBoundingClientRect()
      this.lastPoint = {
        x: e.clientX - rect.left,
        y: e.clientY - rect.top
      }
      this.isEmpty = false

      // 新增: 明确开始新路径并移动到起始点
      this.ctx.beginPath()
      this.ctx.moveTo(this.lastPoint.x, this.lastPoint.y)
    },
    draw(e) {
      if (!this.isDrawing || !this.ctx) return

      const rect = this.$refs.canvas.getBoundingClientRect()
      const currentPoint = {
        x: e.clientX - rect.left,
        y: e.clientY - rect.top
      }

      // 修改: 直接绘制线段，不再重复beginPath和moveTo
      this.ctx.lineTo(currentPoint.x, currentPoint.y)
      this.ctx.stroke()

      this.lastPoint = currentPoint
    },

    stopDrawing() {
      this.isDrawing = false
    },

    clearCanvas() {
      if (!this.ctx || !this.$refs.canvas) return
      this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight)
      this.isEmpty = true
    },
    resetSignature() {
      this.clearCanvas()
      this.removeEventListeners() // 新增: 关闭对话框时移除事件监听
      this.ctx = null // 新增: 释放canvas上下文
    },

    handleResize() {
      if (this.dialogVisible) {
        this.adjustCanvasSize()
        this.resetSignature()
      }
    },
    adjustCanvasSize() {
      const container = document.querySelector('.signature-wrapper')
      if (!container) return

      const maxWidth = Math.min(container.offsetWidth - 2, 550)
      this.canvasWidth = maxWidth
      this.canvasHeight = maxWidth * 0.444 // 保持 9:4 比例
    },
    removeEventListeners() {
      window.removeEventListener('resize', this.resizeCanvas)
    }

  },
  beforeDestroy() {
    if (this.pdfPromise && this.pdfPromise.doc) {
      URL.revokeObjectURL(this.pdfPromise.doc.loadingTask)
    }
    this.removeEventListeners()
  }
}
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}

.content {
  position: relative;
}

.signature-container {
  display: inline-block;
}

.signature-dialog ::v-deep .el-dialog__body {
  padding: 0 20px 15px;
}

.signature-wrapper {
  position: relative;
  margin: 0 auto;
  width: 100%;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  background: #f8fafc;
  margin-top: 20px;
}

.signature-canvas {
  display: block;
  cursor: crosshair;
  background: white;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.placeholder-text {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  color: #c0c4cc;
  font-size: 14px;
  text-align: center;
  pointer-events: none;
  user-select: none;
}

.dialog-footer {
  padding-top: 8px;
}

.pdf-preview {
  width: 100%;
  min-height: 500px;
}


.pdf-container {
  width: 95%;
  padding: 8px 20px;
  overflow: auto;
  margin: 0 auto;
  /* 添加边距 */
}



.pdf-page {
  display: block;
  margin: 10px auto;
  box-shadow: 0 0px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #ddd;
  box-sizing: border-box;
  /* 确保页面居中 */
  max-width: 100%;
}

@media screen and (min-width: 1000px) {
  .content {
    padding: 0 0 0;
  }

  .pageHeader {
    margin: 0 22px;
  }
}

@media screen and (max-width: 1000px) {
  .pdf-container {
    width: 98%;
    padding: 0;
    overflow: auto;
    margin: 0 auto;
    /* 添加边距 */
  }
}

.sign-box {
  width: 100%;
  position: sticky;
  bottom: 0;
  padding: 8px 0;
  box-shadow: 0 0px 8px rgba(0, 0, 0, 0.2);
  background-color: #fff;
  text-align: center;
  left: 0;
}
</style>